module.exports = __webpack_public_path__ + "img/suit-3.67dee7be.jpg";